import {
  AccountBookOutlined,
  BankOutlined,
  BarChartOutlined,
  CalendarOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  FileTextOutlined,
  FolderAddOutlined,
  ReconciliationOutlined,
  SafetyCertificateOutlined,
  TagsOutlined,
  TeamOutlined,
  UserOutlined,
  WalletOutlined
} from "@ant-design/icons";
import type { ReactNode } from "react";

export type NavItem = {
  key: string;
  label: string;
  icon: ReactNode;
  permission?: string;
  children?: NavItem[];
};

export const masterRecordNav: NavItem[] = [
  { key: "/masters/party", label: "Party", icon: <TeamOutlined /> },
  { key: "/masters/bank", label: "Bank", icon: <BankOutlined /> },
  { key: "/masters/short-remarks", label: "Short Remarks", icon: <TagsOutlined />, permission: "ShortRemark.Read" },
  { key: "/masters/sac-codes", label: "SAC Codes", icon: <TagsOutlined /> },
  { key: "/masters/financial-years", label: "Financial Years", icon: <CalendarOutlined /> },
  { key: "/masters/ledgers", label: "Ledgers", icon: <AccountBookOutlined /> },
  { key: "/masters/bill-units", label: "Bill Units", icon: <TagsOutlined /> },
  { key: "/masters/organizations", label: "Manage Company", icon: <DatabaseOutlined /> },
  { key: "/users", label: "Users", icon: <UserOutlined /> },
  { key: "/users/roles", label: "Roles", icon: <SafetyCertificateOutlined /> }
];

export const accountingNav: NavItem[] = [
  { key: "/", label: "Dashboard", icon: <DashboardOutlined /> },
  { key: "/payroll", label: "Attendance & Salary", icon: <TeamOutlined />, permission: "Payroll.Read" },
  {
    key: "entry",
    label: "Entry",
    icon: <FolderAddOutlined />,
    children: [
      { key: "/daily-entry", label: "Daily Entry", icon: <ReconciliationOutlined />, permission: "DailyEntry.Read" },
      { key: "/cash-entry", label: "Cash Entry", icon: <WalletOutlined />, permission: "CashEntry.Read" },
      { key: "/statement-entry", label: "Statement Entry", icon: <FileTextOutlined />, permission: "StatementEntry.Read" }
    ]
  },
  {
    key: "bill-entry",
    label: "Bill Entry",
    icon: <AccountBookOutlined />,
    children: [
      { key: "/bill-entry/sales", label: "Sales", icon: <FileTextOutlined />, permission: "BillEntry.Read" },
      { key: "/bill-entry/purchase", label: "Purchase", icon: <FileTextOutlined />, permission: "BillEntry.Read" },
      { key: "/bill-entry/receipt", label: "Receipt", icon: <WalletOutlined />, permission: "BillEntry.Read" },
      { key: "/bill-entry/payment", label: "Payment", icon: <BankOutlined />, permission: "BillEntry.Read" },
      { key: "/bill-entry/journal", label: "Journal", icon: <ReconciliationOutlined />, permission: "BillEntry.Read" },
      { key: "/bill-entry", label: "All Vouchers", icon: <DatabaseOutlined />, permission: "BillEntry.Read" }
    ]
  },
  {
    key: "reports",
    label: "Reports",
    icon: <BarChartOutlined />,
    children: [
      { key: "/reports", label: "Report Centre", icon: <BarChartOutlined />, permission: "Reports.Read" },
      { key: "/reports/ledger-vouchers", label: "Ledger Vouchers", icon: <FileTextOutlined />, permission: "Reports.Read" },
      { key: "/reports/quote", label: "Quote Generator", icon: <FileTextOutlined />, permission: "Quote.Create" }
    ]
  }
];
